// src/components/layout/CookieConsentBanner.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Si vous avez une page de politique de confidentialité
import './CookieConsentBanner.css';

const COOKIE_CONSENT_KEY = 'infoColabCookieConsent'; // Clé pour le localStorage

function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Vérifie si un choix a déjà été fait
    const consentStatus = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consentStatus) {
      // Affiche le bandeau seulement si aucun choix n'a été enregistré
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (consentType) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, consentType);
    setIsVisible(false);

    if (consentType === 'accepted') {
      // Ici, vous pouvez initialiser des scripts qui dépendent du consentement
      // Par exemple, Google Analytics, Pixel Facebook, etc.
      console.log('Cookies acceptés. Initialisation des services tiers...');
      // Exemple: window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
    } else {
      console.log('Cookies refusés. Certains services pourraient être limités.');
      // Exemple: window.gtag('consent', 'update', { 'analytics_storage': 'denied' });
    }
  };

  if (!isVisible) {
    return null; // Ne rien afficher si le choix a été fait ou si masqué
  }

  return (
    <div 
      className="cookie-consent-banner" 
      role="dialog" 
      aria-labelledby="cookieConsentHeading" 
      aria-describedby="cookieConsentDescription"
      aria-modal="true" // Indique que l'interaction avec le reste de la page peut être limitée
    >
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3 id="cookieConsentHeading" className="cookie-consent-title">🍪 Votre vie privée est importante pour nous</h3>
          <p id="cookieConsentDescription">
            Nous utilisons des cookies essentiels et, avec votre accord, des cookies optionnels pour améliorer votre expérience de navigation et analyser notre trafic.
            {/* Adaptez le lien vers votre page de politique de confidentialité */}
            <Link to="/politique-confidentialite" className="cookie-consent-link"> En savoir plus sur notre politique de cookies</Link>.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button 
            onClick={() => handleConsent('accepted')} 
            className="btn btn-primary btn-cookie-accept"
            aria-label="Accepter tous les cookies"
          >
            Tout Accepter
          </button>
          <button 
            onClick={() => handleConsent('refused')} 
            className="btn btn-secondary btn-cookie-refuse" // btn-secondary est un exemple, adaptez à vos styles
            aria-label="Refuser les cookies optionnels"
          >
            Refuser
          </button>
          {/* Optionnel: bouton pour personnaliser (plus avancé) */}
          {/* <button 
            onClick={() => handleOpenPreferences()} 
            className="btn btn-tertiary btn-cookie-prefs"
          >
            Personnaliser
          </button> 
          */}
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;